export default {
  title: 'Wiki',
  description: 'Een verzameling door gebruikers bijgedragen documentatie en handleidingen.',
  // Voeg meer vertalingen toe indien nodig
};
